<template>
  <div>
    <file-upload
      aspect-ratio="4/3"
      button-id="MyCompanyUpdateLogo"
      qaid="my-company--user-details-logo"
      :in-preset-image-file-url="imageUrl"
      :upload-on-input="true"
      :upload-button="false"
      @file-uploaded="setImage($event)"
    >
      <template slot="help">
        {{ bp('fileTooLarge') }}
      </template>
    </file-upload>
    <trek-button secondary qaid="click-to-upload-button" @click="postImage">
      <span v-html="bp('clickToUpload')"></span>
    </trek-button>
  </div>
</template>

<script>
import axios from 'axios';
import get from 'lodash/get';
import {Url} from '@/utils/url';
import FileUpload from '@/components/FileUpload';
import TrekButton from '@/components/TrekButton';

export default {
  components: {FileUpload, TrekButton},

  props: {
    baseProperties: {
      type: Array,
      default: () => [],
    },
    storeId: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      imageData: {},
    };
  },

  computed: {
    imageUrl() {
      const url = get(this.imageData, 'url', '');
      return url.length > 0 ? Url.appendUrl(url, new Date().getTime().toString()) : '';
    },
  },

  mounted() {
    this.fetchStoreData();
  },

  methods: {
    fetchStoreData() {
      return axios.get(`/b2bunit/getStoreLogoUrl/${this.storeId}`).then(({data: {data}}) => {
        if (data) {
          this.imageData = data;
        }
      });
    },

    postImage() {
      axios.post(`/b2bunit/uploadStoreLogo/${this.storeId}`, this.imageData).then(({data: {data}}) => {
        if (data) {
          this.imageData = data;
        }
      });
    },

    setImage({name, encodedFile}) {
      this.imageData.name = name;
      this.imageData.storeLogo = encodedFile;
    },
  },
};
</script>
